<template>
  <gj-modal
      v-bind="$attrs"
      size="normal"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      no-padding
      @cancel="$emit('cancel')"
      @confirm="confirm">
    <template #header>移动分组</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          style="margin: 20px 0;"
          label-width="170px">
        <el-form-item label="广告组合名称">
          <gj-select
              v-model="form.portfolioId"
              :options="portfolioOption"
              width="220px"
              :clearable="false"
          ></gj-select>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, modalMixIn} from "../../../../../../../minxins";
  import {adStore} from "../../../../common/store";

  export default {
    name: "app-move-portfolio-modal",
    mixins: [modalMixIn, formRuleMixin],
    data() {
      return {
        confirmLoading: false,
        form: {
          portfolioId: null
        },
        portfolioOption: adStore.SP.portfolios.map(e => ({
          id: e.portfolioId,
          text: e.portfolioName,
        }))
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.$emit('confirm');
        }
      }
    }
  }
</script>

<style scoped>
  .form-input {
  
  }
</style>
